import styled, { css } from 'styled-components';

export const StepTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  width: 160px;
  padding-bottom: 5px;
  ${(props) =>
    props.disabled &&
    css`
      color: gray;
    `}
`;

export const HourText = styled.span`
  font-size: 12px;
  padding-bottom: 5px;
  margin-top: 5px;
  white-space: nowrap;
`;
